import React from 'react';

import { PixelsIcon, PercentIcon } from '@vlabs/icons';
import { ButtonSwitch, ButtonSwitchGroup } from '@vlabs/uikit';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import st from './CoordinatesType.module.sass';
import type { TMode } from '../../types';

interface CoordinatesTypeProps {
  value: TMode;
  onChange: (value: string) => void;
  figure?: 'rect' | 'polygon';
}

export function CoordinatesType({
  value,
  onChange,
  figure = 'rect',
}: CoordinatesTypeProps): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <div
      className={cn(st.Root, {
        [st.Root_polygon]: figure === 'polygon',
      })}
    >
      <span className={st.Label}>{t('roi.modal.panel.type')}</span>
      <ButtonSwitchGroup
        onChange={onChange}
        size="small"
        value={value}
      >
        <ButtonSwitch
          icon={<PixelsIcon />}
          value="abs"
        />
        <ButtonSwitch
          disabled={figure === 'polygon'}
          icon={<PercentIcon />}
          value="percent"
        />
      </ButtonSwitchGroup>
    </div>
  );
}
